<template>
  <div class="wrapper-form-input">
    <input
      ref="input"
      v-model="val"
      class="form-input"
      type="text"
      :placeholder="placeholder"
      @keyup.prevent="onChange"
      @change.prevent="change"
      @focus.prevent="focus"
      @blur.prevent="blur" />
    <div v-if="desc" class="gf_sub-desc" v-html="desc" />
  </div>
</template>

<script>
export default {
  name: 'GfInput',
  props: {
    id: [String, Number],
    type: String,
    desc: String,
    placeholder: String,
    value: [String, Number, Boolean, Function, Object],
    readonly: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    screens: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      val: '',
    };
  },
  computed: {},
  watch: {
    value(newV, oldV) {
      if (newV === oldV) return;
      this.val = newV;
    },
  },
  created() {
    // this.val = this.value;
    // this.$emit("created", this);
  },
  unmounted() {
    this.val = '';
  },
  methods: {
    // General Methods
    setValue(value) {
      if (value !== this.val) {
        this.val = value;
      }
    },
    onChange() {
      this.$emit('onChange', this.val);
    },
    change() {
      if (this.val) {
        this.val = this.val.trim();
      }
      this.$emit('change', this.val);
    },
    triggerFocus() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    focus() {
      this.$emit('focus', this.val);
    },
    blur() {
      this.$emit('blur', this.val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.wrapper-form-input {
  .form-input {
    color: $highlight3;
    padding: 9px 8px;
    background: $black;
    border: 1px solid $black3;
    border-radius: $radius;
    -moz-border-radius: $radius;
    -webkit-border-radius: $radius;
    height: 32px;
  }
}
</style>
